// extracted by mini-css-extract-plugin
export default {"card":"Card_card__qdlF5","title":"Card_title__YfUl7","subtitle":"Card_subtitle__cNh79"};